/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Credits_Tab_ConsumeInputs */

const en_settings_credits_tab_consume = /** @type {(inputs: Settings_Credits_Tab_ConsumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consume`)
};

/**
* | output |
* | --- |
* | "Consume" |
*
* @param {Settings_Credits_Tab_ConsumeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_credits_tab_consume = /** @type {((inputs?: Settings_Credits_Tab_ConsumeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Credits_Tab_ConsumeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_credits_tab_consume(inputs)
});
export { settings_credits_tab_consume as "settings.credits.tab_consume" }